import { defineMessages } from 'react-intl';

export const i18n: {
	connectAppsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectAppsButtonAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	connectAppsLabel: {
		id: 'quick_find_connect_apps_label',
		defaultMessage: 'Connect apps',
		description:
			'Label that slides in next to the apps icon when the search bar is opened, indicating the user can connect third-party apps.',
	},
	connectAppsButtonAriaLabel: {
		id: 'quick_find_connect_apps_button_aria_label',
		defaultMessage: 'Open app connections',
		description:
			'Accessible label for the apps button shown at the trailing edge of the search bar.',
	},
});
